/**
 * Куда вернуть пользователя после входа.
 *
 * `RequireAuth` кладёт исходный путь в state роутера. Значение приходит
 * из истории браузера, поэтому проверяется: чужой абсолютный URL в редиректе —
 * это открытый редирект, а не удобство.
 */

export const DEFAULT_REDIRECT = '/tasks'

interface LocationState {
  from?: unknown
}

export function redirectTarget(state: unknown): string {
  const from = (state as LocationState | null)?.from
  if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//')) {
    return DEFAULT_REDIRECT
  }
  return from
}
